export default __webpack_public_path__ + "static/media/31_2_1.6998ef47.png";